import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type QuestionCategory from 'modules/surveys/store/models/QuestionCategory'
import type QuestionsTemplateCategory from 'modules/surveys/store/models/QuestionsTemplateCategory'

interface Props {
  onClose: () => void
  onSubmit: (data: { id: number }) => Promise<unknown>
  category: QuestionCategory | QuestionsTemplateCategory
  questionsCount: number
}

export default function RemoveCategoryModal({
  onClose,
  onSubmit,
  category,
  questionsCount,
}: Props) {
  const { running: deleting, performAction: onDelete } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      onSubmit({
        id: category.attributes.id,
      })
      closePortal()
    },
    {
      errorFlash: true,
      successFlash: true,
    }
  )

  return (
    <Modal
      title={i18n.t('surveys.form.question_categories.delete.title')}
      description={i18n.t('surveys.form.question_categories.delete.description', {
        name: category.name || '',
        questions: questionsCount,
      })}
      illustration="alert"
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('surveys.form.question_categories.delete.cancel')}
          </Button>
          <Button type="negative" disabled={deleting} submit>
            {i18n.t('surveys.form.question_categories.delete.submit')}
          </Button>
        </>
      }
    />
  )
}
